function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import Ajv from 'ajv';
import { objectIdSchema } from "./commonSchemas";
import { unique } from "../../api/utils/filters";
import { wrapValidator } from "../tsUtils";


const ajv = new Ajv({ allErrors: true });
ajv.addVocabulary(['tsType']);

export const emitSchemaTypes = true;

export let AccessLevels = /*#__PURE__*/function (AccessLevels) {AccessLevels["READ"] = "read";AccessLevels["WRITE"] = "write";return AccessLevels;}({});




export let MixedAccess = /*#__PURE__*/function (MixedAccess) {MixedAccess["MIXED"] = "mixed";return MixedAccess;}({});





export let PermissionType = /*#__PURE__*/function (PermissionType) {PermissionType["USER"] = "user";PermissionType["GROUP"] = "group";PermissionType["PUBLIC"] = "public";return PermissionType;}({});





export const permissionType = { type: 'string', enum: Object.values(PermissionType) };
export const permissionLevel = {
  type: 'string',
  enum: Object.values(_objectSpread(_objectSpread({}, AccessLevels), MixedAccess))
};

export const permissionSchema = {
  type: 'object',
  additionalProperties: false,
  definitions: { objectIdSchema },
  properties: {
    refId: objectIdSchema,
    type: permissionType,
    level: permissionLevel
  },
  required: ['refId', 'type', 'level']
};

ajv.addKeyword({
  keyword: 'uniqueIds',
  type: 'object',
  errors: true,
  validate: (fields, data) => {
    const allowedIds = data.permissions.map((item) => item.refId);
    const uniqueIds = allowedIds.filter(unique);
    if (allowedIds.length !== uniqueIds.length) {
      throw new Ajv.ValidationError([
      {
        keyword: 'duplicatedPermissions',
        schemaPath: '',
        params: { keyword: 'duplicatedPermissions', fields },
        message: 'Permissions should be unique by person/group',
        instancePath: '.permissions'
      }]
      );
    }
    return true;
  }
});

export const permissionsDataSchema = {
  type: 'object',
  additionalProperties: false,
  definitions: { objectIdSchema },
  properties: {
    ids: { type: 'array', items: { type: 'string' } },
    permissions: {
      type: 'array',
      items: _objectSpread({}, permissionSchema)
    }
  },
  required: ['ids', 'permissions']
};

export const validateUniquePermissions = wrapValidator(
  ajv.compile({ type: 'object', uniqueIds: true })
);